import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InternationalizationService } from 'app/shared/services/internationalization.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dialog-add-link',
  templateUrl: './dialog-add-link.component.html',
  styleUrls: ['./dialog-add-link.component.scss']
})
export class DialogAddLinkComponent implements OnInit {
	form: UntypedFormGroup;

  constructor(
		private readonly fb: UntypedFormBuilder,
    private readonly toastr: ToastrService,
    private internationalizationService: InternationalizationService,
    private readonly dialogRef: MatDialogRef<DialogAddLinkComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
			link: [null, [Validators.required, Validators.pattern(/(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[/\w?=&#%\s.-]*/)]],
		});
  }

  get link(){
    return this.form.controls['link'];
  }

  onSubmit(): void {
    if(!this.form.valid){
      this.internationalizationService.translate
        .get('city-profile-certification/indicator/link-error')
        .subscribe((text: string) => {
          this.toastr.error(text);
        })
        .unsubscribe();
      return
    }

    this.dialogRef.close(this.form.getRawValue())
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
